// @flow
import createIcon from './utils/createIcon'

export default createIcon({
  iconName: 'reward',
  icon: [
    470,
    496,
    null,
    null,
    'M249 283.76a143.94 143.94 0 0 1-28 0l-122.36 212-20.4-78.5-78.13 21.6 121.6-210.65a141.6 141.6 0 0 1-28.93-85.99C92.78 63.68 156.45 0 235 0s142.22 63.68 142.22 142.22a141.6 141.6 0 0 1-28.93 85.99l121.6 210.66-78.13-21.62-20.4 78.5L249 283.77z',
  ],
})
